import { Component, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api.service';
import { forkJoin, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SalesOrderFileModalComponent } from '../sales-order-file-modal/sales-order-file-modal.component';
import { AdminService } from 'app/admin.service';
import { ApprovalTimelineDialogComponent } from '../../../components/approval-timeline/approval-timeline-dialog.component';
import { ApprovalTimelineData } from '../../../components/approval-timeline/approval-timeline.component';
import { DocumentTracingModalComponent } from 'app/components/document-tracing-modal/document-tracing-modal.component';
import { MatSelect } from '@angular/material/select';
import { CancelApprovalService } from 'app/cancel-approval.service';
import { UiPanelAction, UiPanelMode, UiApprovalStep } from 'app/shared/ui/models/ui-document-panel.model';
import { UiBadgeVariant } from 'app/shared/ui/models/ui-badge.model';
import { UiUnsavedChangesDialogComponent, UnsavedChangesResult } from 'app/shared/ui/document-panel/ui-unsaved-changes-dialog/ui-unsaved-changes-dialog.component';
import { UI_DOCUMENT_PANEL_BREADCRUMBS } from 'app/shared/ui/document-panel/document-panel.config';

@Component({
  selector: 'app-sales-order-dialog',
  templateUrl: './sales-order-dialog.component.html',
  styleUrls: ['./sales-order-dialog.component.scss'],
  host: { class: 'ui-document-panel-host' },
})
export class SalesOrderDialogComponent {
  store: any[] = [];
  store_data: any;
  so_date: any;
  so_no: any;
  customer: any;
  customer_data: any[] = [];
  customerdetails: any = null;
  productList: any[] = [];
  productForm: FormGroup;
  isHsnNo = false;
  isUom = false;
  isDescription = false;
  isStore = false;
  showDetails = false;
  labels: any[] = [];
  products: any[] = [];
  selectedLabel: any;
  flattenedLabels: any[] = [];
  amount: any[] = [];
  maxDate: string = '';
  isUpdateMode:boolean= false; 
  isViewMode:boolean= false;
  panelMode: UiPanelMode = 'create';
  enteredEditFromView = false;
  editSnapshot: string | null = null;
  user_id: any;
  is_short_close = false;
  readonly breadcrumb = UI_DOCUMENT_PANEL_BREADCRUMBS.salesOrder;
  types:any;
  changeqty:any;
  changeprice:any;
  sku_id: any = null;
  combinedDropdownData: any[] = [];
  customerbranch:any;
  selectedBranch:any;
  file: File | null = null;
  myFiles: File[] = [];
  imageUrls: any[] = [];
  documentUrls: any[] = [];
  base64File:any[]=[] ;
  test:boolean=true;
  image_data:any;
  document_no: number = null;
  // profitcost:any[];
  profitCost_data:any[];
  // document_type:any;
  documentTypes = ['Goods','Services'];
  contact_type_id: any;
  contact_type:any;
  contactTypes: any[] = [];
  groupedContactPersons: any[];
  contact_person_id: number;
  private qtyChangeSubject = new Subject<{sublabel: any,qty:any,price:any,product:any }>();
  private priceChangeSubject = new Subject<{sublabel: any,qty:any,price:any }>();
  section_data: any;
  section_ids: any[] = [];
  sections: string = '';
  section: any[];
  profitcosts:string='';
  profitcost_ids: any[] = [];
  selectedContactPersonId: any;
  contactPersons: any[];
  selectedBranchId: any;
  customerid: any;
  customer_branch: any;
  reference_doc:any;
  product_service_no: any;
  hsn_no: any;
  uniqueSkuHsn: any[] = [];
  uniqueServiceSac: any[] = [];
  hsnSacData: { sku: any[]; services: any[] } = { sku: [], services: [] };
  filteredNames: any[] = [];
  unit_data: any = [];
  unit_id: any;
  line_document_type: string = '';
  companyHsnSac: any[] = [];
  line_document_no:any;
  item_id: any = null;
  sku_name: any = null;
  filteredProfitCost: any[] = [];
  profitcost:any
  requisition: any[];
  branch: any;
  branchdata: any[] = [];
  selectedProfitCosts: any[] = [];
  selectedProfitCostId: any;
  selectedSection: any[] = [];
  filteredHeaderSection: any[] = [];
  selectedSectionId:any;
  gstSummary: any[] = [];
  customerGstType:any;
  private amountUpdateScheduled = false;
  selectedProducts: any[] = [];
  customerOffset = 0;
  customerLimit = 100;
  customerHasMore = true;
  loadingCustomer = false;
  customerSearch = '';
  branchOffset = 0;
  branchLimit = 100;
  branchHasMore = true;
  loadingBranch = false;
  branchSearch = '';
  @ViewChild('branchSelect') branchSelect!: MatSelect;
  @ViewChild('customerSelect') customerSelect!: MatSelect;

  constructor(
    private apiService: ApiService, 
    private fb: FormBuilder, 
    public dialogRef: MatDialogRef<SalesOrderDialogComponent> ,
    private adminService: AdminService,
    private cancelApprovalService: CancelApprovalService,
    @Inject(MAT_DIALOG_DATA) public data: {
      section_id?: any;
      name?: any;
      id?: any;
      types?: any;
      approval_status?: any;
      profit_cost_id?: any;
      short_close?: any;
      contact_type_id?: any;
    },
    private dialog: MatDialog) {
    const userString = localStorage.getItem('data');
    const user = JSON.parse(userString) || {};
    this.user_id = user?.id;
    this.types = data?.types;
    if (data?.short_close !== undefined) {
      this.is_short_close = data.short_close === 1;
    }
    console.log('type', this.types);
    console.log('approval_status', data?.approval_status);
    if (data?.id) {
      //this.isUpdateMode = true;

      this.apiService.getSoItem(data?.id).subscribe(
        (response) => {
          // this.fetchProfitCost();
          if (this.data.approval_status === undefined || this.data.approval_status === null) {
            const fetchedStatus = response.details[0].approval_status ?? response?.approval_status ?? null;
            if (fetchedStatus !== undefined && fetchedStatus !== null) {
              this.data.approval_status = fetchedStatus;
            }
          }
          if (response.details[0].short_close !== undefined) {
            this.is_short_close = response.details[0].short_close === 1;
          }
          this.customer = response.details[0].customer_id;
          //this.customerBranchDetails(this.customer);
          this.selectedBranch = response.details[0].customer_branch_id;
          this.so_no = response.details[0].so_no;
          this.so_date = response.details[0].date;
          this.document_no=response.details[0].doc_no;
          //this.fetchBranchData();
          this.branch = response.details[0].branch_id;
           this.fetchProfitCost(this.branch);
          this.profitcosts=response.details[0].profit_cost_id;
          const profitcostIds = this.profitcosts.split(',').map((id) => +id);
          this.profitcost=profitcostIds;
          // this.document_type=response.details[0].document_type;
          this.contact_type_id=response.details[0].contact_type_id;
           this.fetchContactPersons(this.customer, this.selectedBranch);
           this.fetchSection(this.profitcost);
           this.sections= response.details[0].section_id;
          const sectionIds = this.sections.split(',').map((id) => +id);
          this.section=sectionIds;
          this.reference_doc=response.details[0].reference_doc_no;
          console.log('profit cost id1',this.profitcost)
          // this.labels = response.payload;
          // const result = this.extractLevels(this.labels);
          // console.log(result);
          // console.log('update labels',this.labels);
          //this.flattenLabels();
         // this.fetchSkuData();
        // this.fetchCombinedData(this.profitcost,sectionIds);
          forkJoin([
            this.apiService.getBranch(this.customer),
            this.apiService.getDatabranch()
          ]).subscribe(([customerBranches, branches]) => {
            this.customerbranch = customerBranches
              ? customerBranches.data : [];
            this.branchdata = branches;
            this.gstMatch();
            this.labels = response.payload;
            this.labels.forEach((label: any) => {
              label.subLabels.forEach((sublabel: any) => {
                sublabel.products.forEach((product: any) => {
                  const qty = Number(product.quantity || 0);
                  const remainingQty = Number(product.remaining_qty || 0);
                  product.original_qty = qty;
                  product.used_qty = qty - remainingQty;
                  product.min_qty = product.used_qty;
                  product.qty_disabled = remainingQty === 0;
                });
              });
            });
            const result = this.extractLevels(this.labels);
            console.log(result);
            console.log('update labels',this.labels);
            this.flattenLabels();
            this.calculateGSTTotals();
            //console.log(this.calculateGSTTotals());
          });
        },
        (error) => {
          console.error('Error fetching data:', error);
        }
      );
    }
    const scheduleAmountUpdate = () => {
      if (this.amountUpdateScheduled) return;
      this.amountUpdateScheduled = true;
      Promise.resolve().then(() => {
        this.amountUpdateScheduled = false;
        this.onAmountUpdated([]);
      });
    };
    const originalPush = this.amount.push;
    const originalSplice = this.amount.splice;
    this.amount.push = (...items: any[]) => {
      const result = originalPush.apply(this.amount, items);
      console.log('item', items)
      // this.onAmountUpdated(items);
      scheduleAmountUpdate();
      return result;
    }
    this.amount.splice = (start: number, deleteCount?: number, ...items: any[]) => {
      // @ts-ignore - keep same runtime behavior as native splice
      const result = originalSplice.apply(this.amount, [start, deleteCount, ...items]);
      scheduleAmountUpdate();
      return result;
    };
    this.qtyChangeSubject.pipe(debounceTime(1000)).subscribe(({ sublabel,qty,price,product}) => {
          console.log('Labels:', this.labels);
          console.log('Sub Label:', sublabel);
          console.log('Sub qty:', qty);
          console.log('Sub price:', price);
          console.log('product', product);
              if (this.types === 'reopen') {
      const newQty = Number(product.quantity || 0);
      const minQty = Number(product.min_qty || 0);
      if (product.alertShown === undefined) {
        product.alertShown = false;
      }
      if (newQty < minQty) {
        if (!product.alertShown) {
          alert(`Minimum qty is ${minQty}. You cannot enter less than dispatched quantity.`);
          product.alertShown = true;
        }
        product.quantity = product.original_qty;
        product.remaining_qty = product.remaining_qty;
        this.changeqty = product.original_qty;
        this.changeprice = price;
        this.updateLabels(this.labels, sublabel);
        return;
      }
      product.alertShown = false;
      // product.remaining_qty = newQty - minQty;
      // product.qty_disabled = product.remaining_qty === 0;
    }
          this.changeqty=qty
          this.changeprice=price
          this.updateLabels(this.labels, sublabel);
    });
    this.priceChangeSubject.pipe(debounceTime(1000)).subscribe(({ sublabel,qty,price }) => {
      console.log('Labels:', this.labels);
      console.log('Sub Label:', sublabel);
      console.log('Sub qty:', qty);
      console.log('Sub price:', price);
      this.changeqty=qty
      this.changeprice=price
      this.updateLabels(this.labels, sublabel);
    });

    this.initPanelMode();
  }
  updateLabels(labels: any[], slabels: any): any[] {
    console.log('slevel', slabels.level);
    return labels.map(label => {
      if (label.subLabels) {
        const index = label.subLabels.findIndex(subLabel => subLabel.label === slabels.label);
        console.log('index', index);
        console.log('remove sublevel', label.subLabels[index])
        if (index !== -1) {
          console.log("Removed subLabel:", label.subLabels[index]);
          label.subLabels.splice(index, 1, slabels);
          const index1 = this.amount.findIndex(aLabel => aLabel.level === slabels.label);
          if (index1 !== -1) {
            console.log('inside amont push');
            this.amount.splice(index1, 1);
            this.amount.push({ level: slabels.label, amount: this.changeqty * this.changeprice, start_date: slabels?.start_date, end_date: slabels?.end_date })
            console.log('after amount push', this.amount);
            this.calculateGSTTotals();
          }
          console.log("Updated subLabels:", label.subLabels);
        } else {
          label.subLabels = this.updateLabels(label.subLabels, slabels);
        }
      }
      return label;
    });
  }
  //  onQtyChange(sublabel: any, qty: any, price: any) {
  //   this.qtyChangeSubject.next({ sublabel, qty, price });
  // }
  onQtyChange(sublabel: any, qty: any, price: any, product: any) {
    this.qtyChangeSubject.next({ sublabel, qty, price,product });
  }

  onPriceChange(sublabel: any, qty: any, price: any) {
    this.priceChangeSubject.next({ sublabel, qty, price });
  }

  extractLevels(data: any[]): any[] {
    let extractedData: any[] = [];

    const traverse = (node: any) => {
      if (node.products && node.products.length > 0) {
        const product = node.products[0];
        
        // Handle null/undefined price and convert to 0
        const price = product.price !== null && product.price !== undefined ? product.price : 0;
        
        // Handle 'N/A' dates and null/undefined dates
        const startDate = product.start_date && product.start_date !== 'N/A' ? product.start_date : null;
        const endDate = product.end_date && product.end_date !== 'N/A' ? product.end_date : null;
        
        const extractedItem = {
          level: node.label,
          amount: price,
          start_date: startDate,
          end_date: endDate
        };
        extractedData.push(extractedItem);
        this.amount.push(extractedItem);
      }

      if (node.subLabels && node.subLabels.length > 0) {
        node.subLabels.forEach(subLabel => traverse(subLabel));
      }
    };
    data.forEach(item => traverse(item));
    return extractedData;
  }
  
  ngOnInit() {
    // this.fetchProfitCost();
    //this.fetchSkuData();
    this.getcustomer();
    if (!(this.data?.id)) {
      //this.fetchSo();
    }
     this.fetchBranchData();
    this.productForm = this.fb.group({
      sku_id: [''],
      sku_name: [''],
      description: [''],
      uom: [''],
      unit_id: [''],
      hsn_no: [''],
      quantity: [''],
      price: [''],
      discount: [''],
      start_date: [this.maxDate || new Date().toISOString().split('T')[0]],
      end_date: [''],
      store_data: [''],
      store_id: [''],
      line_description: [''],
      product_service_no: [''],
      line_document_no: [''],
      selectedProfitCostId: [''],
      // profit_cost_data: [''],
      profit_cost_id  : [''],
      section_id : [''],
      selectedSectionId:[''],
      line_document_type: [''],
      item_id: ['']
    });

    const today = new Date();
    this.so_date = this.formatDate(today);
    this.maxDate = this.formatDate(today);
    this.productForm.get('start_date')?.valueChanges.subscribe(() => {
      this.validateDates();
    });

    this.productForm.get('end_date')?.valueChanges.subscribe(() => {
      this.validateDates();
    });
    //  this. fetchContactPersonData();
    this.fetchunitData();
  }
   formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  validateDates() {
    const start = this.productForm.get('start_date')?.value;
    const end = this.productForm.get('end_date')?.value;

    if (start && end && new Date(end) < new Date(start)) {
      this.productForm.get('end_date')?.setErrors({ endBeforeStart: true });
    } else {
      this.productForm.get('end_date')?.setErrors(null);
    }
  }
  
  // fetchSo() {
  //   this.apiService.getSoNo().subscribe(
  //     (response) => {
  //       this.so_no = response.so_no;
  //       console.log('so no', this.so_no);
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }

  getcustomer() {
     if (this.loadingCustomer || !this.customerHasMore) {
    return;
  }

  this.loadingCustomer = true;
   const postData = {
     offset: this.customerOffset,
     limit: this.customerLimit,
     search: this.customerSearch || undefined,
     type: "lazyloading",
   };
    this.apiService.getCustomer(postData).subscribe(
      (response) => {
        const data = response?.data ?? response ?? [];
        if (this.customerOffset === 0) {
          this.customer_data = data;
        } else {
          this.customer_data = [...this.customer_data, ...data];
        }
        this.customerOffset += data.length;
        this.customerHasMore = data.length >= this.customerLimit;
        this.loadingCustomer = false;
        // this.customer_data = response;
        console.log('all customer', this.customer_data);
      },
      (error) => {
        this.loadingCustomer = false;
        console.error('Error fetching data:', error);
      }
    );
  }

  customerDetails(id: any) {
    this.apiService.customerbranchdetails(id).subscribe(
      (response) => {
        this.customerdetails = response;
        this.showDetails = true;
        console.log('customerdetails', this.customerdetails);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  customerBranchDetails(id: any) {
    this.apiService.getBranch(id).subscribe(
      (response) => {
        this.customerbranch = response.data;
        console.log('Customer branches:', this.customerbranch);
      },
      (error) => {
        console.error('Error fetching branches:', error);
      }
    );
  }
  
  onCustomerChange(id: any) {
   // this.customerDetails(id);
    this.customerBranchDetails(id);
  }
  // fetchSkuData() {
  //   console.log('sku datass');
  //   this.apiService.getSku().subscribe(
  //     (response) => {
  //       this.productList = response;
  //     },
  //     (error) => {
  //       console.error('Error fetching products:', error);
  //     }
  //   );
  // }

//   fetchContactPersonData() {
//   this.apiService.getContact().subscribe(
//     (response: any[]) => {
//       const grouped: any[] = [];
//       const companyContacts = response.filter(c => c.contact_type === 'Company Contact person');
//       if (companyContacts.length) {
//         grouped.push({
//           contact_type: 'Company Contact person',
//           items: companyContacts
//         });
//       }
//       const customerVendorContacts = response.filter(c => c.contact_type === 'Customer/Vendor Contact Person');
//       if (customerVendorContacts.length) {
//         grouped.push({
//           contact_type: 'Customer/Vendor Contact Person',
//           items: customerVendorContacts
//         });
//       }
//       this.groupedContactPersons = grouped;
//       console.log("Grouped Contacts:", this.groupedContactPersons);
//     },
//     (error) => {
//       console.error('Error fetching contact data:', error);
//     }
//   );
// }


fetchContactPersons(customer_id: any, branch_id: any) {
  this.customerid = customer_id;
  this.selectedBranchId = branch_id;
    this.contactPersons = [];

  this.apiService.getContactsByCustomerBranch(customer_id, branch_id).subscribe(
    (contacts: any[]) => {
      this.contactPersons = contacts || [];
      if (this.data?.id) {
        //this.selectedContactPersonId = this.contactPersons.find(c => c.contact_person_id)?.contact_person_id || null;
        this.selectedContactPersonId = this.contact_type_id;
      } 
    },
    () => {
      this.contactPersons = [];
      this.selectedContactPersonId = null;
    }
  );
}

  fetchBranchData() {
    if (this.loadingBranch || !this.branchHasMore) {
       return;
     }
    this.loadingBranch = true;
    const postData: any = {
      offset: this.branchOffset,
      limit: this.branchLimit,
      type: "lazyloading",
    };
    if (this.branchSearch?.trim()) {
      postData.search = this.branchSearch.trim();
    }
    this.apiService.getDatabranch(postData).subscribe(
      (response) => {
       const branch = response?.branch_data ?? [];
      if (this.branchOffset === 0) {
        this.branchdata = branch;
      } else {
        this.branchdata = [...this.branchdata, ...branch];
      }
      this.branchOffset += branch.length;
      this.branchHasMore = branch.length >= this.branchLimit;
      this.loadingBranch = false;
      console.log('Branch data :', this.branchdata);
      },
      (error) => {
        this.loadingBranch = false;
        console.error('Error fetching data:', error);
      }
    );
  }

  detail() {  //Add product list
    if (this.productForm.valid) {
    const selectedProfitCostId = this.productForm.value.selectedProfitCostId;
    const selectedProfitCost = this.filteredProfitCost.find(pc => pc.id === selectedProfitCostId);
    const selectedSectionId = this.productForm.value.selectedSectionId;
    const selectedsection = this.section_data.find(section => section.id === selectedSectionId);
    console.log('this.productForm.value',this.productForm.value);
      const newProduct = {
        sku_id: this.productForm.value.sku_id  || this.item_id.service_id, // Corrected
        sku_name: this.productForm.value.sku_name || this.item_id.service_name ,
        item_name: this.item_id ? this.item_id.item_name || this.item_id.service_name : '',
        item_id: this.item_id ? this.item_id.item_id || this.item_id.global_service_id : '', // Corrected
        service_name: this.item_id ? this.item_id.item_name || this.item_id.service_name : '',
        type: this.productForm.value.sku_id ? "SKU" : "Service",
        sku_product_type: this.productForm.value.sku_id ? "SKU" : "Service",
        hsn_no: this.productForm.value.hsn_no.hsn_no || '',
        description: this.productForm.value.description || '',
        uom: this.productForm.value.uom.unit_name || '',
        unit_id: this.productForm.value.uom.id || '',
        quantity: this.productForm.value.quantity.toFixed(3),
        price: this.productForm.value.price || 0,
        discount: this.productForm.value.discount || 0,
        start_date: this.productForm.value.start_date,
        end_date: this.productForm.value.end_date||'',
        store_data:this.productForm.value.store_data||'',
        store_id: this.productForm.value.store_id || '',
        unit_price:(this.productForm.value.price || 0).toFixed(2),
        line_description: this.productForm.value.line_description || '',
        section_id: selectedsection ? selectedsection.id : null,
        product_service_no: this.productForm.value.product_service_no || '',
        line_document_no: this.productForm.value.line_document_no || '',
        profit_cost_id: selectedProfitCost ? selectedProfitCost.id : null,
        profit_cost_name: selectedProfitCost ? selectedProfitCost.name : null,
        section_name: selectedsection ? selectedsection.section_name : null,
        gst_percentage: this.productForm.value.hsn_no.gst_percentage,
      };
      console.log('newproduct list',newProduct);
       if (!newProduct) {
        alert('Please select product.');
        return false;
      }
      if (this.selectedLabel == undefined) {
        alert('Please select a label.');
        return false;
      }
      if (!this.selectedLabel) {
        const newLabel = `${this.labels.length + 1}`;
        console.log('newlabel',newLabel );
        this.labels.push({ label: newLabel, products: [newProduct], subLabels: [], level: this.labels.length + 1, type: `header` });
        this.amount.push({ level: newLabel, amount: newProduct.price * newProduct.quantity, start_date: newProduct?.start_date, end_date: newProduct?.end_date })
        console.log('productss', this.labels);
        console.log('product_amount', this.amount);
        this.productForm.reset();

      } else {
        this.addDetail(this.labels, this.selectedLabel, newProduct);
      }
      this.calculateGSTTotals();
      this.selectedLabel = null;
    } else {
      console.log('Form is not valid');
    }
  }

  addDetail(labels: any[], targetLabel: string, productss: any) {
    for (const label of labels) {
      if (label.level === targetLabel) {

        const newSubLabel = `${label.label}.${label.subLabels.length + 1}`;
        console.log('newSubLabel',newSubLabel );
        label.subLabels.push({ label: newSubLabel, products: [productss], subLabels: [], level: `${label.label}.${label.subLabels.length + 1}`, type: `header` });
        this.amount.push({ level: newSubLabel, amount: productss.price * productss.quantity, start_date: productss?.start_date, end_date: productss?.end_date })
        console.log('subproductss label', label);
        console.log('subproductss', label.subLabels);
        console.log('subproduct_amount', this.amount);
        this.productForm.reset();
        this.calculateGSTTotals();
        return;
      }
      if (label.subLabels && label.subLabels.length > 0) {
        this.addDetail(label.subLabels, targetLabel, productss);
      }
    }
  }

  // fetchHsnNo(productId: any) {  //Get Hsn no by sku id
  //   this.apiService.getSkuHsnNo(productId).subscribe(
  //     (response) => {
  //       if (response && response.hsn_no) {
  //         this.productForm.patchValue({
  //           uom: response.unit_name,
  //           unit_id: response.unit_id,
  //           hsn_no: response.hsn_no,
  //           description: response.description,
  //           store_data:response.store_name,
  //           store_id: response.store_id,
  //         });
  //       }
  //       this.isHsnNo = true;
  //       this.isUom = true;
  //       this.isDescription = true;
  //       this.isStore=true;
  //     },
  //     (error) => {
  //       console.error('Error fetching HSN number:', error);
  //     }
  //   );
  // }
  // fetchhsnno(data: any) {
  //   this.apiService.gethsnno(data,'Sales').subscribe(
  //     (response) => {
  //       this.productForm.patchValue({
  //       // hsn_no: response.hsn_no,
  //       ledger_name: response.ledger_name,
  //       ledger_id: response.ledger_id,
  //       // uom: response.unit_name,
  //       // unit_id: response.unit_id,
  //       description: response.description,
  //       store_data:response.store_name,
  //       store_id: response.store_id,
  //       });
  //       // this.isHsnNo = true;
  //       // this.isUom = true;
  //       this.isDescription = true;
  //       this.isStore=true;
  //     },
  //     (error) => {
  //       console.error('Error fetching voucher number:', error);
  //     }
  //   );
  // }
  flattenLabels() {
    const result: any[] = [];
    const recursiveFlatten = (labels: any[], parentLabel = '') => {
      for (const label of labels) {
        if (label.type == 'item') {
          result.push(label.level);
        }
        if (label.subLabels && label.subLabels.length > 0) {
          recursiveFlatten(label.subLabels, label.level);
        }
      }
    };
    recursiveFlatten(this.labels);
    this.flattenedLabels = result;
    console.log('all level', this.flattenedLabels);
  }

  summary() {
    console.log('selected labels',this.selectedLabel);
    if (!this.selectedLabel) {
      const newLabel = `${this.labels.length + 1}`;
      this.labels.push({
        label: newLabel, products: [{
          "start_date": "",
          "end_date": "",
          "price": 0,
          "profit_cost_id": ""
        }], subLabels: [], level: this.labels.length + 1, type: `item`
      });
      this.amount.push({ level: newLabel, amount: 0, start_date: '', end_date: '' })
      console.log('summery_product', this.labels);
      console.log('summery_product_amount', this.amount);
    } else {
      this.addSummary(this.labels, this.selectedLabel);
    }
    this.flattenLabels();
    this.selectedLabel = null;
  }
  addSummary(labels: any[], targetLabel: string,) {
    for (const label of labels) {
      if (label.level === targetLabel) {
        const newSubLabel = `${label.label}.${label.subLabels.length + 1}`;
        label.subLabels.push({
          label: newSubLabel, products: [{
            "start_date": "",
            "end_date": "",
            "price": 0,
            "profit_cost_id": ""
          }], subLabels: [], level: `${label.label}.${label.subLabels.length + 1}`, type: `item`
        });
        this.amount.push({ level: newSubLabel, amount: 0, start_date: '', end_date: '' })
        console.log('summery_subproduct_amount', label.subLabels);
        console.log('summery_subproduct_amount', this.amount);
      }
      if (label.subLabels && label.subLabels.length > 0) {
        this.addSummary(label.subLabels, targetLabel);
      }
    }
  }


  save(exitAfterSave: 'close' | 'view' = 'close') {
    console.log('all labels of save ', this.labels);
    if (!this.customer) {
      alert('Please select Customer');
      return;
    }
    if(!this.selectedBranch){
      alert('Please select Customer Branch');
      return;
    }
    if(!this.branch){
      alert('Please select Branch');
      return;
    }
    if(!this.profitcost || this.profitcost.length === 0){
      alert('Please select Profit/Cost Center');
      return;
    }
    if(!this.section || this.section.length === 0){
      alert('Please select Section');
      return;
    }
    if(!this.so_date){
      alert('Please fill Date');
      return;
    }
    const mapAllProducts = (labels: any[]) => {
      console.log('labelss', labels);
      let allProducts: any[] = [];

      labels.forEach((label) => {
        console.log('products',labels);
        const labelProducts = (label.products.length > 0
          ? label.products.map((product) => ({
            sku_id: product.sku_id || "",
            sku_product_type: product.type || "",
            description: product.line_description || "",
            qty: product.quantity || "",
            unit: product.unit_id || "",
            price: product.price || "",
            hsn_no: product.hsn_no || "",
            store_id:product.store_id || "",
            start_date: product.start_date || "",
            end_date: product.end_date || "",
            label: label.label || "",
            labelDescription: label.description || "",
            type:label.type || "",
            unit_price:product.unit_price ||"",
            section_id: product.section_id || "",
            product_service_no: product.product_service_no || "",
            line_document_no: product.line_document_no || "",
            profit_cost_id: product.profit_cost_id ?? null,
            gst_percentage: product.gst_percentage, 
            remaining_qty:product.remaining_qty || 0,
            original_qty: product.original_qty??0,
          }))
          : [
            {
              sku_id: "",
              sku_product_type: "",
              description: "",
              qty: "",
              unit: "",
              price: "",
              hsn_no: "",
              store_id:"",
              start_date: "",
              end_date: "",
              label: label.label || "",
              labelDescription: label.description || "",
              type:label.type || "",
              unit_price:"",
              section_id:"",
              product_service_no:"",
              line_document_no:"",
              profit_cost_id: null, 
              gst_percentage: null,
              remaining_qty:0,
              original_qty:0,
            },
          ]);

        allProducts = allProducts.concat(labelProducts);

        // Recursively process subLabels
        if (label.subLabels && label.subLabels.length > 0) {
          const subLabelProducts = mapAllProducts(label.subLabels);
          allProducts = allProducts.concat(subLabelProducts);
        }
      });

      return allProducts;
    };
    const hasSubLabels = Array.isArray(this.labels) && this.labels.some((label: any) => label.subLabels && label.subLabels.length > 0);
    if (!hasSubLabels) {
      alert('At least one detailed summary line should be added');
      return;
    }
    const payload = {
      customer_id: this.customer,
      customer_branch_id: this.selectedBranch,
      so_no: this.so_no || null,
      date: this.so_date,
      type:this.types??'',
      doc_no: this.document_no??'',
      selectedProducts: mapAllProducts(this.labels),
      uploaded_files: this.base64File.map(file => file.file),
      profit_cost_id:this.profitcost?? 0,
      // document_type: this.document_type??'',
      contact_type_id :this.selectedContactPersonId,
      section:this.section??'',
      reference_doc_no:this.reference_doc??'',
      branch_id:this.branch,
    };
    
    if (!payload.selectedProducts || payload.selectedProducts.length === 0) {
      alert("Please add at least one item/service.");
      return;
    }
    console.log('Final Payload:', payload);
// return;
    if (this.data?.id) {
      this.apiService.updateso(this.data?.id, payload).subscribe(
        (response) => {
          console.log('Sales order Updated', response);
          alert('Sales order Updated successfully.');
          if (exitAfterSave === 'view') {
            this.enterViewMode();
            this.editSnapshot = this.captureEditSnapshot();
          } else {
            this.dialogRef.close(response);
          }
        },
        (error) => {
          console.error('Error saving data:', error);
          alert('Failed to save sales order. Please try again.');
        }
      );

    } else {
      this.apiService.createso(payload).subscribe(
        (response) => {
          console.log('Sales order created', response);
          alert('Sales order created successfully.');       
          // this.dialogRef.close({ id: response.data.id, action: 'create' });
          this.dialogRef.close(response);
        },
        (error) => {
          console.error('Error saving data:', error);
          alert('Failed to save sales order. Please try again.');
        }
      );
    }
  }

  onAmountUpdated(items: any[]) {
    console.log('item',items);
    let total_amount = [];
    let final_dates = [];
    console.log('Updated amount array:', this.amount);

    const lastnode = this.findLastNodes(this.amount);
    console.log(lastnode, "sdasdasda")
    lastnode.forEach((node) => {
      let level = node.level.split('.');
      let amount = node.amount;
      let start_date = node?.start_date ?? '';
      let end_date = node?.end_date ?? '';
      const updatedData = this.generateHierarchyArray(level, amount, start_date, end_date);
      console.log(updatedData, 'dasdasdasdadasdas');
      updatedData.forEach((level_item) => {
        console.log(level_item, "[[[[[[[[[[")
        if (!total_amount[`l${level_item.level}`]) {
          total_amount[`l${level_item.level}`] = 0;
        }

        // Add the amount to the corresponding level
        total_amount[`l${level_item.level}`] += level_item.amount;


        if (!final_dates[`s${level_item.level}`]) {
          final_dates[`s${level_item.level}`] = [];
        }

        if (!final_dates[`e${level_item.level}`]) {
          final_dates[`e${level_item.level}`] = [];
        }

        // Add the amount to the corresponding level
        final_dates[`s${level_item.level}`].push(level_item?.start_date);
        final_dates[`e${level_item.level}`].push(level_item?.end_date);

      })

    })

    for (let target in total_amount) {
      const cleanedTarget = target.replace(/^l/, ""); // Remove the "l" prefix
      for (let i = 0; i < this.amount.length; i++) {
        if (this.amount[i].level === cleanedTarget) {
          const earliestDate = this.findEarliestAndLatestDates(final_dates[`s${cleanedTarget}`]);
          const latestDate = this.findEarliestAndLatestDates(final_dates[`e${cleanedTarget}`]);
          console.log(final_dates[`s${cleanedTarget}`], "sssssss");
          console.log(final_dates[`e${cleanedTarget}`], "eeeeeee");

          this.amount[i].amount = total_amount[target]; // Update the amount
          this.amount[i].start_date = earliestDate.earliest;
          this.amount[i].end_date = latestDate.latest;
        }
      }
    }

    console.log(this.amount, "doneeeeeeeee")
    console.log(final_dates, "datesssssssss")
    this.mergeDataWithLevels(this.labels, this.amount);
    console.log(this.labels, "labelssssssssss")
  }

  mergeDataWithLevels(data: any[], amountArray: any[]): any[] {
    return data.map((item) => {
      // Find the matching level from the amountArray
      const match = amountArray.find((entry) => entry.level == item.level);

      // Update the products within the current item
      if (item.products) {
        item.products = item.products.map((product) => ({
          ...product,
          price: match?.amount || product.price || 0,
          start_date: match?.start_date || product.start_date || "N/A",
          end_date: match?.end_date || product.end_date || "N/A",
        }));
      }
      if (item.type == "item" && match?.amount != 0 && item.subLabels.length == 0) {
        match.amount = 0;
        match.start_date = '';
        match.end_date = '';
      }
      // If the item has subLabels, apply the same logic recursively
      if (item.subLabels) {
        item.subLabels = this.mergeDataWithLevels(item.subLabels, amountArray);
      }

      // Add amount, start_date, and end_date to the current label level
      return {
        ...item,
        price: match?.amount || 0,
        start_date: match?.start_date || "N/A",
        end_date: match?.end_date || "N/A",
      };
    });
  }

  findEarliestAndLatestDates(dates: string[]): { earliest: string | null; latest: string | null } {
    // Filter out invalid dates (empty strings)
    const validDates = dates.filter(date => date.trim() !== '');

    if (validDates.length === 0) {
      // Return null if no valid dates are found
      return { earliest: null, latest: null };
    }

    // Find the earliest and latest dates
    const earliestDate = new Date(Math.min(...validDates.map(date => new Date(date).getTime())));
    const latestDate = new Date(Math.max(...validDates.map(date => new Date(date).getTime())));

    // Format the dates in YYYY-MM-DD format
    return {
      earliest: earliestDate.toISOString().split('T')[0],
      latest: latestDate.toISOString().split('T')[0],
    };
  }

  findLastNodes(data: any) {
    const lastNodes: any[] = [];
    const dates: any[] = []

    data.forEach((node) => {
      console.log(node, "*********")
      const isParent = data.some((other) => other.level.startsWith(`${node.level}.`));
      if (!isParent) {
        lastNodes.push({ "level": node.level, "amount": node.amount, "start_date": node.start_date, "end_date": node.end_date });
      }
    });

    return lastNodes;
  }

  generateHierarchyArray(input: any, amount: any, start_date: any, end_date: any) {
    const result: any[] = [];
    let currentHierarchy = "";

    for (let i = 0; i < input.length - 1; i++) {
      // Build the hierarchy by appending the current number
      currentHierarchy = currentHierarchy ? `${currentHierarchy}.${input[i]}` : `${input[i]}`;
      // result.push({level:currentHierarchy,amount:amount});
      result.push({ level: currentHierarchy, amount: amount, start_date: start_date, end_date: end_date });
    }

    return result;
  }



  //delete So
 deleteLabelAndProducts(label: any): void {
    console.log('label', label);
    const recursiveDelete = (labels: any[], targetLabel: any) => {
      for (let i = 0; i < labels.length; i++) {
        if (labels[i] === targetLabel) {
          labels.splice(i, 1);
          return true;
        }
        if (labels[i].subLabels && labels[i].subLabels.length > 0) {
          const foundAndDeleted = recursiveDelete(labels[i].subLabels, targetLabel);
          if (foundAndDeleted) return true;
        }
      }
      return false;
    };
    recursiveDelete(this.labels, label);
     this.on_delete_amount(label.level);
    this.update_array(this.labels, label);
    this.updateSelectedProducts();
    this.flattenLabels();
     this.calculateGSTTotals();
  }

  update_array(labels: any[], targetLabel: any): void {
    this.updateLevels(this.amount, targetLabel);
    let counter = 0;
    const recursiveUpdate = (labels: any[], targetLevel: number): void => {
      counter++;
      for (let i = 0; i < labels.length; i++) {
        if (this.check_string(labels[i].level) > targetLevel) {
          const _decreased_level = this.decreaseLevel(labels[i].level);
          labels[i].level = _decreased_level;
          labels[i].label = _decreased_level;
          if (labels[i].subLabels && labels[i].subLabels.length > 0) {
            recursiveUpdate(labels[i].subLabels, targetLevel);
          }
        }
      }
    };
    recursiveUpdate(labels, targetLabel.level);
    console.log(labels, "Updated labels");
    console.log(targetLabel, "Target label");
    this.calculateGSTTotals();
  }

  decreaseLevel(level) {
    if (typeof level !== 'string') {
      console.error("Input should be a string.");
      return level - 1;
    }
    if (level.includes('.')) {
      const parts = level.split('.');
      const firstPart = parseInt(parts[0], 10) - 1;
      if (firstPart < 1) {
        console.warn("The first segment cannot be less than 1.");
        return level;
      }
      parts[0] = firstPart.toString();
      return parts.join('.');
    } else {
      const num = parseInt(level, 10);
      if (num <= 1) {
        console.warn("Cannot decrease further, level is already at 1.");
        return level;
      }
      return (num - 1).toString();
    }
  }

  check_string(level) {
    if (typeof level !== 'string') {
      console.error("Input should be a string.");
      return level;
    }
    if (level.includes('.')) {
      const parts = level.split('.');
      var firstPart = parseInt(parts[0], 10);
    }
    return firstPart;
  }
  updateSelectedProducts(): void {
    this.selectedProducts = this.labels.flatMap((label) =>
      label.products.concat(
        label.subLabels.flatMap((subLabel) => subLabel.products)
      )
    );
  }

  updateLevels(data: any[], targetLevel: any) {
    // Filter out the target level and all its children
    const filteredData = data.filter((item) => !item.level.startsWith(targetLevel));

    // Find the target level to replace (e.g., "2" to "1")
    const targetLevelNumber = targetLevel;
    const newBaseLevel = targetLevelNumber + 1;

    // Update the levels of the remaining items
    return filteredData.map((item) => {
      const levelParts = item.level.split(".");
      const topLevel = parseInt(levelParts[0], 10);

      // If the top level matches the target level, adjust it
      if (topLevel >= newBaseLevel) {
        levelParts[0] = `${topLevel - 1}`;
      }

      return {
        ...item,
        level: levelParts.join("."),
      };
    });
  }



  onSelectionChange(selected: any) {
    this.item_id = selected;
    // this.fetchhsnno(selected);
    this.fetchSkuByItemId(selected?.item_id);
  }
  fetchSkuByItemId(item_id: any) {
    const selectedProfitCostId = this.productForm.get('selectedProfitCostId')?.value;
    const selectedSectionId = this.productForm.get('selectedSectionId')?.value;
    const postData = {
       item_id: item_id,
       profit_cost_id: selectedProfitCostId,
       section_id: selectedSectionId, 
      };
    this.apiService.showSkuByItemId(postData).subscribe(
      (itemData) => {
        if (itemData) {
          console.log("Selected Item Sku:", itemData);
          this.productForm.patchValue({
            sku_id: itemData.sku_id || '',
            sku_name: itemData.sku_name || '',
            store_data: itemData.store_name || '',
            store_id: itemData.store_id || '',
            section_id: itemData.section_id || '',
          });
          this.isStore = true;
        }
      },
      (error) => {
        console.error("Error fetching item data:", error);
      }
    );
  }
 
  // fetchCombinedData(profit_cost_id: any, section_id: number[]) {
  //   this.section_ids = section_id;
  //   this.profitcost_ids = profit_cost_id;
  //   const postData = {
  //     profit_cost_id: profit_cost_id,
  //     section_id: section_id
  //   };

  //   this.apiService.getSkuBySection(postData).subscribe(
  //     (skuResponse) => {
  //       console.log('item data', skuResponse);
  //       this.apiService.getServiceOfSection(postData).subscribe(
  //         (serviceResponse) => {
  //           const combined = [];
  //           if (skuResponse.length > 0) {
  //             combined.push({ category: 'SKU', items: skuResponse.map(item => ({ ...item, type: 'SKU' })) });
  //           }
  //           if (serviceResponse.length > 0) {
  //             combined.push({ category: 'Service', items: serviceResponse.map(item => ({ ...item, type: 'Service' })) });
  //           }
  //           this.combinedDropdownData = combined;
  //           console.log('this.combinedDropdownData',this.combinedDropdownData);
  //         },
  //         (error) => {
  //           console.error('Error fetching service data:', error);
  //           if (skuResponse.length > 0) {
  //             this.combinedDropdownData = [
  //               { category: 'SKU', items: skuResponse.map(item => ({ ...item, type: 'SKU' })) }
  //             ];
  //           } else {
  //             this.combinedDropdownData = [];
  //           }
  //         }
  //       );
  //     },
  //     (error) => {
  //       console.error('Error fetching SKU data:', error);
  //       this.apiService.getServiceOfSection(postData).subscribe(
  //         (serviceResponse) => {
  //           if (serviceResponse.length > 0) {
  //             this.combinedDropdownData = [
  //               { category: 'Service', items: serviceResponse.map(item => ({ ...item, type: 'Service' })) }
  //             ];
  //           } else {
  //             this.combinedDropdownData = [];
  //           }
  //         },
  //         (serviceError) => {
  //           console.error('Error fetching service data:', serviceError);
  //           this.combinedDropdownData = [];
  //         }
  //       );
  //     }
  //   );
  // }

  onDocumentTypeChange(type: string) {
    this.line_document_type = type;
    const selectedProfitCostId = this.productForm.get('selectedProfitCostId')?.value;
    const details = {
      profit_cost_id: selectedProfitCostId,
      document_type: type
    }
    this.hsnSac(details); // refresh options
    // this.form.get('hsn_no')?.reset(); // clear old selection
  }
  hsnSac(details:any) {
    this.apiService.getCompanyHsnSac(details).subscribe(
      (hsnsacresponse) => {
        // Ensure keys exist and are arrays
        this.hsnSacData = {
          sku: Array.isArray(hsnsacresponse.sku) ? hsnsacresponse.sku : [],
          services: Array.isArray(hsnsacresponse.services) ? hsnsacresponse.services : []
        };
        this.uniqueHsnSac();
      },
      (error) => {
        console.error("Error fetching HSN/SAC data:", error);
        this.hsnSacData = { sku: [], services: [] };
        this.companyHsnSac = [];
      }
    );
  }


  uniqueHsnSac() {
    if (!this.hsnSacData) {
      console.warn("hsnSacData not loaded yet");
      this.companyHsnSac = [];
      return;
    }
    this.uniqueSkuHsn = (this.hsnSacData.sku || []).filter(
      (value, index, self) =>
        index === self.findIndex(t => t.hsn_id === value.hsn_id)
    );
    this.uniqueServiceSac = (this.hsnSacData.services || []).filter(
      (value, index, self) =>
        index === self.findIndex(t => t.hsn_id === value.hsn_id)
    );
    if (this.line_document_type === 'Goods') {
      this.companyHsnSac = this.uniqueSkuHsn;
    } else if (this.line_document_type === 'Services') {
      this.companyHsnSac = this.uniqueServiceSac;
    } else {
      this.companyHsnSac = [];
    }
  }

  onHsnSacChange(selected: any) {
    if (selected.item_id) {
      this.filteredNames = this.hsnSacData.sku.filter(s => s.hsn_id === selected.hsn_id);
    } else if (selected.global_service_id) {
      this.filteredNames = this.hsnSacData.services.filter(s => s.hsn_id === selected.hsn_id);
    } else {
      this.filteredNames = [];
    }
    // this.fetchunitData();
  }

  fetchunitData() {
    this.adminService.getGlobalUnit().subscribe(
      (response) => {
        this.unit_data = response;
        console.log('UNIT data:', this.unit_data);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  onSectionChange(section_id: any) {
    console.log('header checked section change',section_id);
    const startDate = this.productForm.get('start_date')?.value;
    this.productForm.reset({
    start_date: startDate
  });
   this.selectedSection = this.section_data
    .filter(section => section_id.includes(section.id))
    .map(section => ({
      id: section.id,
      section_name: section.section_name,
      profit_cost_id:section.profit_cost_id
    }));
     console.log('Section data by pc/cc:', this.selectedSection);
  }

  lineItemSection(pc_cc_id: any) {
    this.filteredHeaderSection = this.selectedSection.filter(
      (section) => section.profit_cost_id === pc_cc_id
    );
    console.log('Line item section', this.filteredHeaderSection);
  }

  getTitle(): string {
    return this.types === 'create' ? 'Create Sales Order' : 'Update Sales Order';
  }

   getFileDetails(files: FileList) {
      for (let i = 0; i < files?.length; i++) {
        this.myFiles.push(files[i]);
      }
      console.log("filesss", this.myFiles);
    }
  
    removeFile(index: number) {
      this.myFiles.splice(index, 1);
      if (this.base64File?.length > index) {
        this.base64File.splice(index, 1);
      }
    }
  
    onFileSelected(event: any) {
      const files: FileList = event?.target?.files;
      if (!files || files.length === 0) return;
      this.getFileDetails(files);
      this.convertFileToBase64(files);
    }


    openFileShowModal() {
      if (this.data.id) {
        this.apiService.getSalesOrderFiles(this.data.id).subscribe(
          (response) => {
            this.image_data = response.uploadedFiles; 
            console.log('Data from API:', this.image_data);
    
            this.dialog.open(SalesOrderFileModalComponent, {
              width: '1200px',
                  height: '600px',
              data: {  id: this.data.id ,images: this.image_data } 
            });
          },
          (error) => {
            console.error("Error fetching images:", error);
          }
        );
      } else {
        console.error("Invalid data ID.");
      }
    }
    
    
    isImage(extension: string): boolean {
      const imageExtensions = ['jpeg', 'jpg', 'png', 'svg', 'gif'];
      return imageExtensions.includes(extension.toLowerCase());
    }
  
    isDocument(extension: string): boolean {
      const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx'];
      return documentExtensions.includes(extension.toLowerCase());
    }
  
    convertFileToBase64(files: FileList) {
      this.base64File = this.base64File || [];

  
      for (let i = 0; i < files?.length; i++) {
        const reader = new FileReader();
        reader.onload = () => {
          const resultAsString = reader.result as string;
          this.base64File.push({ file: resultAsString });
          console.log('Base64 Data:', this.base64File);
        };
        reader.onerror = error => {
          console.error('Error reading file:', error);
        };
        reader.readAsDataURL(files[i]);
      }
    }

    // fetchProfitCost() {   //all profit cost center
    //   this.apiService.getProfitCostCenter().subscribe(
    //     (response) => {
    //       this.profitCost_data = response.data;
    //       console.log('profit cost center data', this.profitCost_data);
    //     },
    //     (error) => {
    //       console.error('Error fetching data:', error);
    //     }
    //   );
    // }
     fetchProfitCost(branch_id: any) {
      this.profitcost='';
      this.section=[];
      this.requisition=[];
      this.productList=[];
      this.labels=[];
        const postData = {
          branch_id: branch_id
        };
        this.apiService.getProfitCostByBranch(postData).subscribe(
          (response) => {
            this.profitCost_data = response;
            console.log('profit center', this.profitCost_data);
             this.filteredProfitCost = this.profitCost_data;
            console.log('filtered profit center', this.filteredProfitCost);
          if (this.isUpdateMode && this.profitcost?.length > 0) {
            this.selectedProfitCosts = this.filteredProfitCost
            .filter(pc => this.profitcost.includes(pc.id))
           .map(pc => ({ id: pc.id, name: pc.name }));
          console.log('Prefilled Profit/Cost Centers:', this.selectedProfitCosts);
            this.filteredProfitCost = this.filteredProfitCost.map(pc => ({
              ...pc,
              disabled: this.profitcost.includes(pc.id),
            }));
         }
          },
          (error) => {
            console.error('Error fetching data:', error);
          }
        );
      }
      
    onProfitCostChange(event: any) {
    const selectedIds = event.value;
    this.selectedProfitCosts = this.filteredProfitCost
     .filter(pc => selectedIds.includes(pc.id))
    .map(pc => ({ id: pc.id, name: pc.name }));
    console.log("Checked Profit/Cost Centers:", this.selectedProfitCosts);
   }

    allowOnlyNumbers(event: KeyboardEvent): boolean {
      const charCode = event.key;
      if ((charCode >= '0' && charCode <= '9') || charCode === '.') {
        return true;
      }
      event.preventDefault();
      return false;
    }

    onBranchChange(branch_id:any) {
      this.customerDetails(branch_id);
    }

  fetchSection(profit_id: any) {
    const postData = {
      profit_cost_id: profit_id,
    };
    this.apiService.sectionsByProfitCost(postData).subscribe(
      (response) => {
        this.section_data = response;
        console.log('main section header',this.section_data);
        if (this.isUpdateMode && this.profitcost?.length > 0) {
          this.setSelectedSection(this.sections);
          const selectedIds = this.section.map((id) => Number(id));
          this.section_data = this.section_data.map((section) => ({
            ...section,
            disabled: selectedIds.includes(section.id),
          }));

          this.selectedSection = this.section_data
            .filter(section => this.section.includes(section.id))
            .map(section => ({ id: section.id, section_name: section.section_name , profit_cost_id:section.profit_cost_id}));
        }
        console.log('Section data by pc/cc:', this.selectedSection);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  } 
    setSelectedSection(sectionIds: string) {
    const sectionsIds = sectionIds.split(',').map((id) => +id);
    this.section_ids = sectionsIds,
    this.section = sectionsIds;
  }

  //gst comparision of branch and customer branch
  gstMatch(): boolean {
    const selectedBranch = this.branchdata.find(
      (branch: any) => branch.id === this.branch
    );
    const branchGstFirstTwoDigits = selectedBranch?.gst?.substring(0, 2);

    const selectedCustomerBranch = this.customerbranch.find(
      (customerBranch: any) => customerBranch.id === this.selectedBranch
    );
    const customerBranchGstFirstTwoDigits = selectedCustomerBranch?.gst_number?.substring(0, 2);
    this.customerGstType = selectedCustomerBranch?.gst_type || '';
    console.log('gst type', this.customerGstType);
    if (!branchGstFirstTwoDigits || !customerBranchGstFirstTwoDigits) {
      return false;
    }
    return branchGstFirstTwoDigits === customerBranchGstFirstTwoDigits;
  }
 //percentage calculation
  getCGSTPercentage(gstpercent: number): string | number {
    if (this.customerGstType === 'UNREGISTERED' || this.customerGstType === 'NA') return 'NA';
    if (this.customerGstType === 'SEZ' || this.customerGstType === 'COMPOSITE') return 0;
    if (!this.gstMatch()) return 0;
    const gstPercentage = gstpercent || 0;
    return gstPercentage / 2;
  }
  getSGSTPercentage(gstpercent: number): string | number {
    if (this.customerGstType === 'UNREGISTERED' || this.customerGstType === 'NA') return 'NA';
    if (this.customerGstType === 'SEZ' || this.customerGstType === 'COMPOSITE') return 0;
    if (!this.gstMatch()) return 0;
    const gstPercentage = gstpercent || 0;
    return gstPercentage / 2;
  }
  getIGSTPercentage(gstpercent: number): string | number {
    if (this.customerGstType === 'UNREGISTERED' || this.customerGstType === 'NA') return 'NA';
    if (this.customerGstType === 'SEZ' || this.customerGstType === 'COMPOSITE') return 0;
    if (this.gstMatch()) return 0;
    const gstPercentage = gstpercent || 0;
    return gstPercentage;
  }
//gst amount calculation
  cgstAmount(qty: any, price: any, gst: any) {
    if (this.customerGstType === 'UNREGISTERED' || this.customerGstType === 'NA') return 'NA';
    if (this.customerGstType === 'SEZ' || this.customerGstType === 'COMPOSITE') return '0.00';
    if (!this.gstMatch()) return '0.00';
    let value = qty * price;
    const taxableValue = value;
    return ((taxableValue * gst) / 2 / 100).toFixed(2);
  }

  sgstAmount(qty: any, price: any, gst: any) {
    if (this.customerGstType === 'UNREGISTERED' || this.customerGstType === 'NA') return 'NA';
    if (this.customerGstType === 'SEZ' || this.customerGstType === 'COMPOSITE') return '0.00';
    if (!this.gstMatch()) return '0.00';
    let value = qty * price;
    const taxableValue = value;
    return ((taxableValue * gst) / 2 / 100).toFixed(2);
  }

  igstAmount(qty: any, price: any, gst: any) {
    if (this.customerGstType === 'UNREGISTERED' || this.customerGstType === 'NA') return 'NA';
    if (this.customerGstType === 'SEZ' || this.customerGstType === 'COMPOSITE') return '0.00';
    if (this.gstMatch()) return '0.00';
    let value = qty * price;
    const taxableValue = value;
    return ((taxableValue * gst) / 100).toFixed(2);
  }

//total gst
  calculateGSTTotals() {
    const gstTotals: { [gstPercent: number]: { totalPrice: number } } = {};
    const items = Array.isArray(this.labels) ? this.labels : [this.labels];
    
    const traverse = (node: any) => {
      if (node.products && node.products.length > 0) {
        node.products.forEach((product: any) => {
          const gst = Number(product.gst_percentage);
          const qty = Number(product.quantity) || 0;
          const unitPrice = Number(product.unit_price) || 0;
          const totalPrice = qty * unitPrice;

          if (!isNaN(gst)) {
            if (!gstTotals[gst]) {
              gstTotals[gst] = { totalPrice: 0 };
            }
            gstTotals[gst].totalPrice += totalPrice;
          }
        });
      }
      if (node.subLabels && node.subLabels.length > 0) {
        node.subLabels.forEach((subLabel: any) => traverse(subLabel));
      }
    };

    items.forEach(item => traverse(item));

    const gstMatch = this.gstMatch();
    const result: any[] = [];
    Object.entries(gstTotals).forEach(([gstPercent, { totalPrice }]) => {
      const gst = Number(gstPercent);
      if (gst === 0 || isNaN(gst)) return;
      
      const gstAmount = (totalPrice * gst) / 100;
      if (this.customerGstType === 'UNREGISTERED' || this.customerGstType === 'NA') {
        result.push({
          gst_percent: 'NA',
          cgst: 'NA',
          sgst: 'NA',
          igst: 'NA',
        });
      } else if (this.customerGstType === 'SEZ' || this.customerGstType === 'COMPOSITE') {
        result.push({
          gst_percent: gst,
          cgst: '0.00',
          sgst: '0.00',
          igst: '0.00',
        });
      } else if (this.customerGstType === 'REGISTER') {
        if (gstMatch) {
          result.push({
            gst_percent: gst,
            cgst: (gstAmount / 2).toFixed(2),
            sgst: (gstAmount / 2).toFixed(2),
            igst: '0.00',
          });
        } else {
          result.push({
            gst_percent: gst,
            cgst: '0.00',
            sgst: '0.00',
            igst: gstAmount.toFixed(2),
          });
        }
      } else {
        result.push({
          gst_percent: 'NA',
          cgst: 'NA',
          sgst: 'NA',
          igst: 'NA',
        });
      }
    });
    this.gstSummary = result;
    console.log('gst summary', this.gstSummary);
    return result;
  }

    /**
   * Calculate the optimal width for the customer field based on content length
   * @returns Width in pixels for the customer field
   */
  getCustomerFieldWidth(): number {
    if (!this.customer_data || this.customer_data.length === 0) {
      return 250; // Default width
    }

    // Find the longest customer name
    const longestName = this.customer_data.reduce((longest, current) => {
      return (current.customer_name && current.customer_name.length > longest.length) 
        ? current.customer_name 
        : longest;
    }, '');

    // Calculate width based on character count
    // Approximate: 8px per character + padding + dropdown arrow
    const baseWidth = Math.max(longestName.length * 8, 20);
    const totalWidth = baseWidth + 80; // Add padding and dropdown arrow space
    
    // Set reasonable min/max bounds
    return Math.min(Math.max(totalWidth, 200), 500);
  }

  /**
   * Calculate the optimal width for the customer branch field based on content length
   * @returns Width in pixels for the customer branch field
   */
  getCustomerBranchFieldWidth(): number {
    if (!this.customerbranch || this.customerbranch.length === 0) {
      return 250; // Default width
    }

    // Find the longest branch name
    const longestName = this.customerbranch.reduce((longest, current) => {
      return (current.branch_name && current.branch_name.length > longest.length) 
        ? current.branch_name 
        : longest;
    }, '');

    // Calculate width based on character count
    // Approximate: 8px per character + padding + dropdown arrow
    const baseWidth = Math.max(longestName.length * 8, 20);
    const totalWidth = baseWidth + 80; // Add padding and dropdown arrow space
    
    // Set reasonable min/max bounds
    return Math.min(Math.max(totalWidth, 200), 500);
  }

  /**
   * Calculate the optimal width for the profit cost center field based on content length
   * @returns Width in pixels for the profit cost center field
   */
  getProfitCostFieldWidth(): number {
    if (!this.profitCost_data || this.profitCost_data.length === 0) {
      return 250; // Default width
    }

    // Find the longest profit cost center name
    const longestName = this.profitCost_data.reduce((longest, current) => {
      return (current.name && current.name.length > longest.length) 
        ? current.name 
        : longest;
    }, '');

    // Calculate width based on character count
    // Approximate: 8px per character + padding + dropdown arrow
    const baseWidth = Math.max(longestName.length * 8, 20);
    const totalWidth = baseWidth + 80; // Add padding and dropdown arrow space
    
    // Set reasonable min/max bounds
    return Math.min(Math.max(totalWidth, 200), 500);
  }

  /**
   * Calculate the optimal width for the section field based on content length
   * @returns Width in pixels for the section field
   */
  getSectionFieldWidth(): number {
    if (!this.section_data || this.section_data.length === 0) {
      return 250; // Default width
    }

    // Find the longest section name
    const longestName = this.section_data.reduce((longest, current) => {
      return (current.section_name && current.section_name.length > longest.length) 
        ? current.section_name 
        : longest;
    }, '');

    // Calculate width based on character count
    // Approximate: 8px per character + padding + dropdown arrow
    const baseWidth = Math.max(longestName.length * 8, 20);
    const totalWidth = baseWidth + 80; // Add padding and dropdown arrow space
    
    // Set reasonable min/max bounds
    return Math.min(Math.max(totalWidth, 200), 500);
  }

  sendForApprove(type?:any) {
    
    const requestData = {
      document_type: 'SalesOrder',
      document_id: this.data.id,
      reopen:type=="reopen"?"true":"false",
      // profit_cost_id: this.data.profit_cost_id,
    };
    this.apiService.sendForApproval(requestData).subscribe(
      (response) => {
        console.log('Sales Order sent for approval:', response);
        // if(type=="reopen"){
        //   alert('Document now at open stage');
        //   this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
        // }else{
          alert('Document sent for approval');
          this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
        // }
       
      },
      (error) => {
        console.error('Error sending sales order for approval:', error);
        alert('Error sending sales order for approval: ' + error.error.message);
      }
    );
  }

  showApprovalTimeline() {
    const requestData = {
      document_type: 'SalesOrder',
      document_id: this.data.id,
    };

    this.apiService.getApprovalTimeline(requestData).subscribe(
      (response) => {
        console.log('Approval timeline data:', response);
        
        // Open approval timeline dialog with real data
        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: response.data || response }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      },
      (error) => {
        console.error('Error fetching approval timeline:', error);
        
        // Fallback to demo data if API fails
        const demoApprovalData: ApprovalTimelineData = {
          document_id: this.data.id || 12345,
          document_type: 'Sales Order',
          current_stage: 2,
          total_stages: 4,
          overall_status: 'pending',
          created_at: new Date().toISOString(),
          created_by: 'Current User',
          stages: [
            {
              id: 1,
              name: 'Department Head Review',
              level: 1,
              status: 'approved',
              approver_name: 'Sarah Johnson',
              approved_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
              comments: 'All requirements met, approved for next level',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 2,
              name: 'Finance Manager Review',
              level: 2,
              status: 'pending',
              is_current: true,
              timeline: [],
              pending_time_seconds: 7200,
              pending_time_formatted: '2h 0m 0s',
              cancellation_count: 0
            },
            {
              id: 3,
              name: 'General Manager Approval',
              level: 3,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 4,
              name: 'Final Approval',
              level: 4,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            }
          ]
        };

        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: demoApprovalData }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      }
    );
  }

  viewRelatedDocuments(salesOrderId: number): void {
    const payload = {
      document_id: salesOrderId,
      document_type: "sales_order"
    };

    // Show loading state
    const loadingDialog = this.dialog.open(DocumentTracingModalComponent, {
      width: '90%',
      maxWidth: '1200px',
      height: '80%',
      maxHeight: '800px',
      disableClose: false,
      data: {
        tracingData: null,
        loading: true
      }
    });

    this.apiService.getDocumentTracing(payload).subscribe(
      (response) => {
        if (response.status) {
          // Close loading dialog and open with data
          loadingDialog.close();

          const dialogRef = this.dialog.open(DocumentTracingModalComponent, {
            width: '90%',
            maxWidth: '1200px',
            height: '80%',
            maxHeight: '800px',
            disableClose: false,
            data: {
              tracingData: {
                ...response.data,
                document_type: "sales_order",
                current_document: response.data.current_document || `SO${salesOrderId}` // Ensure current document is set
              },
              loading: false
            }
          });

          dialogRef.afterClosed().subscribe(() => {
            console.log('Document tracing modal closed');
          });
        } else {
          loadingDialog.close();
          alert('Error: ' + response.message);
        }
      },
      (error) => {
        loadingDialog.close();
        console.error('Error fetching document tracing:', error);

        let errorMessage = 'Error fetching related documents. Please try again.';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        alert(errorMessage);
      }
    );
  }

   deleteSubLabel(subLabel: any) {
    console.log('deleteSubLabel', subLabel);
    // 1. Remove from amount array using splice (this will trigger the overridden splice -> onAmountUpdated)
    // Remove the exact level and any descendants (e.g. "2.1" and "2.1.1", "2.1.2"...)
    // for (let i = this.amount.length - 1; i >= 0; i--) {
    //   const level = this.amount[i]?.level;
    //   if (level === subLabel.level || (typeof level === 'string' && level.startsWith(subLabel.level + '.'))) {
    //     this.amount.splice(i, 1);
    //   }
    // }
    this.on_delete_amount(subLabel.level);
    // 2. Remove from labels tree and trigger renumbering
    this.removeAndRenumber(this.labels, subLabel);
    // 3. Update other states
    this.updateSelectedProducts();
    this.flattenLabels();
    this.calculateGSTTotals();
  }

  removeAndRenumber(labels: any[], targetLabel: any, parentLevel: string = ''): boolean {
    const index = labels.indexOf(targetLabel);
    if (index !== -1) {
      // Found it in this array
      labels.splice(index, 1);
      // Renumber this array starting from 0 (all siblings)
      this.renumberItems(labels, parentLevel);
      return true;
    }
    // Not found, look in children
    for (const label of labels) {
      if (label.subLabels && label.subLabels.length > 0) {
        if (this.removeAndRenumber(label.subLabels, targetLabel, label.level)) {
          return true;
        }
      }
    }
    return false;
  }

  renumberItems(items: any[], parentLevel: string) {
    items.forEach((item, index) => {
      const newLevel = parentLevel ? `${parentLevel}.${index + 1}` : `${index + 1}`;
      // Update level if it changed
      if (item.level !== newLevel) {
        this.updateAmountLevel(item.level, newLevel);
        item.level = newLevel;
        item.label = newLevel;
      }
      // Always recurse to maintain consistency for nested items
      if (item.subLabels && item.subLabels.length > 0) {
        this.renumberItems(item.subLabels, newLevel);
      }
    });
  }

  updateAmountLevel(oldLevel: string, newLevel: string) {
    // Find exact match in amount array and update it
    const amt = this.amount.find(a => a.level === oldLevel);
    if (amt) {
      amt.level = newLevel;
    }
  }

  check_label_amount() {
    console.log("labelssssssssssss", this.labels);
    console.log("amountttttttttt", this.amount);
    // Force running the same aggregation logic that runs on amount.push
    // This will recompute hierarchy totals/dates based on current this.amount
    this.onAmountUpdated([]);
  }

  // on_delete_amount(delete_level:any){
  //   for (let i = this.amount.length - 1; i >= 0; i--) {
  //     const level = this.amount[i]?.level;
  //     console.log( "levelsssssssss",level);
  //     console.log( "delete_levelddddddd",delete_level);
  //     console.log( "level.startsWith(delete_level + '.')",level?.startsWith(delete_level + '.'));
  //     if (level == delete_level || (level.startsWith(delete_level + '.'))) {
  //       console.log( "levelsssssssss inside if",level);
  //     console.log( "delete_levelddddddd inside if",delete_level);
  //     console.log("level.startsWith(delete_level + '.') inside if",level?.startsWith(delete_level + '.'));
  //       this.amount.splice(i, 1);
  //     }
  //   }
  // }


  on_delete_amount(deleteLevel: any) {
    deleteLevel = String(deleteLevel);
    const parts = deleteLevel.split('.');
    const deletedIndex = Number(parts[parts.length - 1]);
    const parentPrefix = parts.slice(0, -1).join('.'); // "" | "1" | "1.2"
    /* ---------------- STEP 1: REMOVE SUBTREE (IN-PLACE) ---------------- */
    for (let i = this.amount.length - 1; i >= 0; i--) {
      const level = this.amount[i].level;
      if (level == deleteLevel || level.startsWith(deleteLevel + '.')) {
        this.amount.splice(i, 1);
      }
    }
    /* ---------------- STEP 2: RENNUMBER REMAINING LEVELS ---------------- */
    for (let i = 0; i < this.amount.length; i++) {
      const item = this.amount[i];
      const levelParts = item.level.split('.');
      // CASE A → same depth sibling shift
      if (levelParts.length == parts.length) {
        const itemParent = levelParts.slice(0, -1).join('.');
        const itemIndex = Number(levelParts[levelParts.length - 1]);
        if (itemParent === parentPrefix && itemIndex > deletedIndex) {
          levelParts[levelParts.length - 1] = String(itemIndex - 1);
          item.level = levelParts.join('.');
          continue;
        }
      }
      // CASE B → deeper children prefix shift
      const oldPrefix =
        (parentPrefix ? parentPrefix + '.' : '') + (deletedIndex + 1);
      if (item.level.startsWith(oldPrefix + '.')) {
        const newPrefix =
          (parentPrefix ? parentPrefix + '.' : '') + deletedIndex;
        item.level = item.level.replace(oldPrefix, newPrefix);
      }
    }
  }
getCustomerName(customerId: any) {
  if(!customerId) return '';
  const customer = this.customer_data.find(c => c.id == customerId);
  return customer ? customer.customer_name : '';
}
getBranchName(branchId: any) {
  if(!branchId) return '';
  const branch = this.customerbranch.find(b => b.id == branchId);
  return branch ? branch.branch_name : '';
}
getCustomerBranchName(branchId: any) {
  if(!branchId) return '';
  const branch = this.branchdata.find(b => b.id == branchId);
  return branch ? branch.name : '';
}
getProfitCostNames(ids: any[]) {
  if (!ids || !ids.length) return '';
  return this.filteredProfitCost
    .filter(item => ids.includes(item.id))
    .map(item => item.name)
    .join(', ');
}
getErpCodes(ids: any[]) {
  if (!ids || !ids.length) return '';

  return this.filteredProfitCost
    .filter(item => ids.includes(item.id))
    .map(item => item.erp_code)
    .join(', ');
}
getSectionNames(ids: any[]) {
  if (!ids || !ids.length) return '';
  return this.section_data
    .filter(item => ids.includes(item.id))
    .map(item => item.section_name)
    .join(', ');
}
onCustomerSearch(value: string) {
  this.customerSearch = value || '';
  this.customerOffset = 0;
  this.customerHasMore = true;
  this.customer_data = [];
  this.getcustomer();
}
onCustomerOpen(opened: boolean) {
  if (!opened) return;
  this.customerOffset = 0;
  this.customerHasMore = true;
  this.customer_data = [];
  this.getcustomer();
  Promise.resolve().then(() => {
    const panel = this.customerSelect?.panel?.nativeElement;
    if (!panel) return;
    panel.removeEventListener('scroll', this.onCustomerScroll);
    panel.addEventListener('scroll', this.onCustomerScroll);
  });
}
onCustomerScroll = (event: any) => {
  const panel = event.target as HTMLElement;
  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.customerHasMore &&
    !this.loadingCustomer
  ) {
    this.getcustomer();
  }
};
onBranchSearch(value: string) {
  this.branchSearch = value || '';
  this.branchOffset = 0;
  this.branchHasMore = true;
  this.branchdata = [];
  this.fetchBranchData();
}
onBranchOpen(opened: boolean) {
  if (!opened) {
    return;
  }
  if (this.branchdata.length === 0) {
    this.fetchBranchData();
  }
  setTimeout(() => {
    const panel = this.branchSelect?.panel?.nativeElement;
    if (!panel) {
      return;
    }
    panel.removeEventListener('scroll', this.onBranchScroll);
    panel.addEventListener('scroll', this.onBranchScroll);
  });
}
onBranchScroll = (event: any) => {
  const panel = event.target as HTMLElement;
  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 50 &&
    !this.loadingBranch &&
    this.branchHasMore
  ) {
    this.fetchBranchData();
  }
};

  get isInputDisabled(): boolean {
    return this.panelMode === 'view';
  }

  private initPanelMode(): void {
    const t = (this.types || '').toLowerCase();
    if (t === 'view') {
      this.panelMode = 'view';
      this.isViewMode = true;
      this.isUpdateMode = true;
    } else if (t === 'create') {
      this.panelMode = 'create';
      this.isViewMode = false;
      this.isUpdateMode = false;
    } else {
      this.panelMode = 'edit';
      this.isViewMode = false;
      if (this.data?.id) this.isUpdateMode = true;
    }
  }

  get panelTitle(): string {
    switch (this.panelMode) {
      case 'create': return 'Create Sales Order';
      case 'edit': return 'Edit Sales Order';
      case 'view': return 'View Sales Order';
      default: return 'Sales Order';
    }
  }

  get statusLabel(): string {
    if (!this.data?.id) return 'Draft';
    return this.data.approval_status || 'Open';
  }

  get statusVariant(): UiBadgeVariant {
    const status = this.data?.approval_status;
    if (!this.data?.id || status == null || status === 'Open') return 'default';
    if (status === 'Approved') return 'approved';
    if (status === 'Pending') return 'pending';
    if (status === 'Rejected') return 'rejected';
    return 'default';
  }

  get approvalSteps(): UiApprovalStep[] {
    const status = this.data?.approval_status;
    const steps: UiApprovalStep[] = [
      { id: 'draft', label: 'Draft', icon: 'edit_note', state: 'upcoming' },
      { id: 'pending', label: 'Pending Approval', icon: 'schedule', state: 'upcoming' },
      { id: 'approved', label: 'Approved', icon: 'check_circle', state: 'upcoming' },
    ];
    if (!this.data?.id) { steps[0].state = 'active'; return steps; }
    if (status == null || status === 'Open') steps[0].state = 'active';
    else if (status === 'Pending') { steps[0].state = 'completed'; steps[1].state = 'active'; }
    else if (status === 'Approved') { steps[0].state = 'completed'; steps[1].state = 'completed'; steps[2].state = 'completed'; }
    else if (status === 'Rejected') { steps[0].state = 'completed'; steps[1].state = 'rejected'; }
    return steps;
  }

  canEdit(): boolean {
    const status = this.data?.approval_status;
    return status == null || status === 'Open' || status === 'Rejected';
  }

  enterEditMode(): void {
    if (!this.canEdit()) return;
    this.enteredEditFromView = true;
    this.panelMode = 'edit';
    this.isViewMode = false;
    this.isUpdateMode = true;
    this.types = 'update';
    this.editSnapshot = this.captureEditSnapshot();
  }

  enterViewMode(): void {
    this.panelMode = 'view';
    this.isViewMode = true;
    this.isUpdateMode = true;
    this.types = 'view';
    this.enteredEditFromView = false;
    this.editSnapshot = null;
  }

  private captureEditSnapshot(): string {
    return JSON.stringify({
      customer: this.customer,
      selectedBranch: this.selectedBranch,
      branch: this.branch,
      profitcost: this.profitcost,
      section: this.section,
      document_no: this.document_no,
      reference_doc: this.reference_doc,
      so_date: this.so_date,
      labels: this.labels,
      selectedContactPersonId: this.selectedContactPersonId,
    });
  }

  hasUnsavedChanges(): boolean {
    if (this.panelMode !== 'edit' || !this.editSnapshot) return false;
    return this.captureEditSnapshot() !== this.editSnapshot;
  }

  private restoreFromSnapshot(): void {
    if (!this.editSnapshot) return;
    const s = JSON.parse(this.editSnapshot);
    this.customer = s.customer;
    this.selectedBranch = s.selectedBranch;
    this.branch = s.branch;
    this.profitcost = s.profitcost;
    this.section = s.section;
    this.document_no = s.document_no;
    this.reference_doc = s.reference_doc;
    this.so_date = s.so_date;
    this.labels = s.labels;
    this.selectedContactPersonId = s.selectedContactPersonId;
  }

  onClose(): void { this.handleExitIntent('close'); }

  onCancel(): void {
    if (this.panelMode === 'edit' && this.enteredEditFromView) {
      this.handleExitIntent('view');
      return;
    }
    this.handleExitIntent('close');
  }

  private handleExitIntent(intent: 'close' | 'view'): void {
    if (this.panelMode === 'edit' && this.hasUnsavedChanges()) {
      this.promptUnsavedChanges(intent);
      return;
    }
    this.executeExitIntent(intent);
  }

  private executeExitIntent(intent: 'close' | 'view'): void {
    if (intent === 'view') this.enterViewMode();
    else this.dialogRef.close();
  }

  private promptUnsavedChanges(intent: 'close' | 'view'): void {
    const promptRef = this.dialog.open(UiUnsavedChangesDialogComponent, {
      width: '440px', disableClose: true, panelClass: 'ui-unsaved-changes-dialog',
    });
    promptRef.afterClosed().subscribe((result: UnsavedChangesResult | undefined) => {
      if (!result || result === 'cancel') return;
      if (result === 'discard') { this.restoreFromSnapshot(); this.executeExitIntent(intent); return; }
      if (result === 'save') this.save(intent);
    });
  }

  get footerPrimaryActions(): UiPanelAction[] {
    if (this.panelMode === 'view') {
      return this.canEdit() ? [{ id: 'edit', label: 'Edit', icon: 'edit', variant: 'primary', visible: true }] : [];
    }
    return [
      { id: 'save', label: 'Save', icon: 'save', variant: 'success', visible: !this.isInputDisabled },
      { id: 'send-approval', label: 'Send for Approval', icon: 'send', variant: 'primary',
        visible: !!this.data?.id && this.canEdit() },
    ];
  }

  get footerSecondaryActions(): UiPanelAction[] {
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', variant: 'outline',
        visible: !!this.data?.id && this.panelMode !== 'view' },
      { id: 'timeline', label: 'Approval Timeline', icon: 'timeline', variant: 'outline',
        visible: !!this.data?.id && ['Pending', 'Rejected', 'Approved'].includes(this.data.approval_status) && this.panelMode !== 'view' },
      { id: 'cancel', label: this.panelMode === 'view' ? 'Close' : 'Cancel', icon: 'close', variant: 'ghost', visible: true },
    ];
  }

  get footerDestructiveAction(): UiPanelAction | null {
    const status = this.data.approval_status;
    if (this.panelMode !== 'view' || !this.data?.id|| status === 'Approved' || status === 'Pending') return null;
    return { id: 'delete', label: 'Delete', icon: 'delete', variant: 'danger', visible: true };
  }

  get footerOverflowActions(): UiPanelAction[] {
    if (this.panelMode !== 'view' || !this.data?.id) return [];
    const status = this.data.approval_status;
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', visible: true },
      { id: 'timeline', label: 'Approval Timeline', icon: 'timeline',
        visible: ['Pending', 'Rejected', 'Approved'].includes(status) },
      { id: 'short-close', label: 'Short Close', icon: 'block', visible: status === 'Approved' && !this.is_short_close },
      { id: 'reopen', label: 'Reopen', icon: 'replay', visible: status === 'Approved' },
      { id: 'cancel-approval', label: 'Cancel Approval', icon: 'cancel', visible: status === 'Pending' && this.user_id === 1 },
    ];
  }

  onFooterAction(actionId: string): void {
    switch (actionId) {
      case 'save': this.save(); break;
      case 'send-approval': this.sendForApprove(); break;
      case 'tracing': if (this.data?.id) this.viewRelatedDocuments(this.data.id); break;
      case 'timeline': this.showApprovalTimeline(); break;
      case 'edit': this.enterEditMode(); break;
      case 'delete': this.deleteSo(); break;
      case 'short-close': this.shortCloseSo(); break;
      case 'reopen': this.onReopen(); break;
      case 'cancel-approval': this.onCancelApproval(); break;
      case 'cancel': this.onCancel(); break;
    }
  }

  getSkuIds(): any[] {
    const skuIds: any[] = [];
    const extractSkuIds = (labels: any[]) => {
      if (!labels) return;
      labels.forEach((label) => {
        if (label.products) {
          label.products.forEach((product: any) => {
            const id = product.sku_id?.id || product.sku_id || product.item_id?.id || product.item_id;
            if (id) {
              skuIds.push(id);
            }
          });
        }
        if (label.subLabels && label.subLabels.length > 0) {
          extractSkuIds(label.subLabels);
        }
      });
    };
    extractSkuIds(this.labels);
    return [...new Set(skuIds.filter(Boolean))];
  }

  deleteSo(): void {
    if (!this.data?.id) return;
    const skuIds = this.getSkuIds();
    console.log('delete sku', skuIds);

    this.apiService.checkNextDocument({
      doc_id: this.data.id,
      model: 'SalesOrder',
      sku_id: skuIds,
      type: 'delete'
    }).subscribe((res: any) => {
      if (res.status === false) {
        alert(res.message);
        return;
      } else {
         if (confirm('Are you sure you want to delete this Sales Order?')) {
          this.apiService.deleteso(this.data.id).subscribe(
            (response) => { 
              alert(response.message); 
              this.dialogRef.close({ id: this.data.id, action: 'delete' }); 
            },
            (error) => alert(error.error?.message)
          );
        }
      }
    });
  }


  shortCloseSo(): void {
    if (!this.data?.id) return;
    // const payload = { so_id: this.data.id, type: 'short_close' };
    // this.apiService.soShortClose(payload).subscribe(
    //   (response) => { alert(response.message); this.dialogRef.close({ id: this.data.id, action: 'short_close' }); },
    //   (error) => alert(error.error?.message || 'Failed to short close sales order.')
    // );
    const skuIds = this.getSkuIds();
    console.log('short close sku', skuIds);
    this.apiService.checkNextDocument({
      doc_id: this.data.id,
      model: 'SalesOrder',
      sku_id: skuIds,
      type: 'short_close'
    }).subscribe((res: any) => {
      if (res.status) {
        if (res.status === false) {
          alert(res.message);
        }
        if (confirm('Do you want to short close this document?')) {
          console.log("short close So", this.data);
          const payload = { so_id: this.data.id, type: 'short_close' };
          this.apiService.soShortClose(payload).subscribe(
            (response) => {
              alert(response.message);
              this.dialogRef.close({ id: this.data.id, action: 'short_close' });
            },
            (error) => alert(error.error?.message)
          );
        }
      }
    });
  }

  onReopen(): void {
    if (!this.data?.id) return;
    const postData = { doc_id: this.data.id, model: 'SalesOrder', type: 'reopen' };
     if (confirm('Do you want to reopen this document?')) {
    this.apiService.checkNextDocument(postData).subscribe({
      next: (res: any) => {
        if (res.status === true) {
          this.types = 'reopen';
          this.panelMode = 'edit';
          this.isViewMode = false;
          this.data.approval_status = 'Open';
        } else {
          alert(res.message);
        }
      },
      error: () => alert('Something went wrong!'),
    });
     } else {
       return;
     }
  }

  onCancelApproval(): void {
    if (!this.data?.id) return;
    if (confirm('Do you want to cancel approval for this document?')) {
    this.cancelApprovalService.cancelApproval(this.data.id, 'SalesOrder', () => {
      this.data.approval_status = 'Open';
      this.enterViewMode();
    });
    } else {
      return;
    }
  }
}
